import { IClaims } from "../../data/AppInterface";
import { TBitValue, TReactSetState } from "../../data/AppType";
import {
  ACTIVE_INACTIVE_CLAIM_GROUP,
  DELETE_CLAIM_GROUP,
  GET_ALL_CLAIM_GROUP,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
  toastSuccess,
} from "../../utils/AppFunctions";

export interface IClaimGroup {
  id: string;
  claim_group_name: string;
  claims: IClaims[];
  is_active: TBitValue;
  is_deleted?: TBitValue;
}

export interface IClaimOtherGroup {
  id: string;
  claim_name: string;
  is_active: TBitValue;
  is_deleted?: TBitValue;
}

export const getAllClaimGroup = async (
  setClaimGroupList: TReactSetState<IClaimGroup[]>,
  setClaimOtherGroupList: TReactSetState<IClaimOtherGroup[]>
) => {
  try {
    const claimGroupCode = await GET_ALL_CLAIM_GROUP();
    if (claimGroupCode && claimGroupCode.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setClaimGroupList(claimGroupCode.data.item);
      setClaimOtherGroupList(claimGroupCode.data.other_claims);
    } else {
      setClaimGroupList([]);
      setClaimOtherGroupList([]);
      sweetAlertError({
        message: claimGroupCode.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllClaimGroup");
  }
};

export const activeInactiveClaimGroup = async (
  id: string,
  values: TBitValue
) => {
  try {
    const activeInactiveData = await ACTIVE_INACTIVE_CLAIM_GROUP(id, {
      is_active: values,
    });
    if (
      activeInactiveData &&
      activeInactiveData.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      toastSuccess(activeInactiveData.message);
      return true;
    } else {
      sweetAlertError({
        message: activeInactiveData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "activeInactiveClaimGroup");
    return false;
  }
};

export const deleteClaimGroup = async (id: string) => {
  try {
    const deleteData = await DELETE_CLAIM_GROUP(id);
    if (deleteData && deleteData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deleteData.message });
      return true;
    } else {
      sweetAlertError({
        message: deleteData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteClaimGroup");
    return false;
  }
};
